import React from 'react';
import { VulnerabilityData, CHART_COLORS } from '../../../../types/dashboard-v4.types';
import { PanelHeading } from './PanelHeading';

interface VulnerabilityMetricProps {
  data: VulnerabilityData;
}

export const VulnerabilityMetric: React.FC<VulnerabilityMetricProps> = ({ data }) => {
  return (
    <div className="bg-white p-6 rounded-lg shadow-sm">
      <PanelHeading>
        Vulnerability detection
      </PanelHeading>
      
      <div className="space-y-4">
        <div className="text-center">
          <div 
            className="text-5xl font-bold mb-2"
            style={{ color: '#6B21A8' }}
          >
            {data.percentage}%
          </div>
        </div>
        
        {/* Progress bar */}
        <div className="relative w-full h-2 bg-gray-200 rounded-full overflow-hidden">
          <div 
            className="absolute top-0 left-0 h-full rounded-full transition-all duration-300"
            style={{ 
              width: `${data.percentage}%`,
              backgroundColor: '#6B21A8'
            }}
          />
        </div>
        
        <p className="text-xs text-gray-600 text-center">
          Percentage of signals flagged as vulnerable
        </p>
        
        <div className="pt-2 space-y-1">
          <div className="flex justify-between items-baseline">
            <span className="text-2xl font-bold text-gray-900">{data.signalCount} Signals</span>
          </div>
          
          {data.weeklyChange && (
            <div className="text-xs text-gray-500 text-right">
              +{data.weeklyChange} vs. last session
            </div>
          )}
        </div>
      </div>
    </div>
  );
};